import { useCampaign } from '../contexts/CampaignContext'
import './MobileSidebar.css'

function MobileSidebar({ activeTab, onTabChange, isOpen, onClose, counts = {}, campaign = null }) {
  const { tabs } = useCampaign()

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose}></div>}

      {/* Sidebar */}
      <aside className={`mobile-sidebar ${isOpen ? 'active' : ''}`}>
        <div className="sidebar-header">
          <h1>{campaign?.logoEmoji || '🧭'}</h1>
          <h2>{campaign?.name || 'Start your Quest'}</h2>
        </div>

        <nav className="sidebar-nav">
          {tabs.map((item) => {
            const count = item.countKey ? counts[item.countKey] : null
            return (
              <button
                key={item.id}
                className={`nav-item ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => onTabChange(item.id)}
              >
                <span className="icon">{item.icon}</span>
                <span className="label">{item.sidebarLabel}</span>
                {count !== null && count !== undefined && count > 0 && (
                  <span className="count-badge">{count}</span>
                )}
              </button>
            )
          })}
        </nav>

        {campaign?.subtitle && (
          <div className="sidebar-footer">
            <div className="campaign-badge">
              <div className="badge-label">Campaign</div>
              <div className="badge-value">{campaign.subtitle}</div>
            </div>
          </div>
        )}
      </aside>
    </>
  )
}

export default MobileSidebar
